import client from './client';

const API_URL = '/api/school-days';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchSchoolDays = async (start, end) => {
  try {
    const response = await client.get(API_URL, {
      params: { start, end },
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching school days:', error);
    throw error;
  }
};

export const createSchoolDay = async (date, name) => {
  try {
    const response = await client.post(API_URL, { date, name }, { headers: getAuthHeaders() });
    return response.data;
  } catch (error) {
    console.error('Error creating school day:', error);
    throw error;
  }
};

export const deleteSchoolDay = async (id) => {
  try {
    const response = await client.delete(`${API_URL}/${id}`, { headers: getAuthHeaders() });
    return response.data;
  } catch (error) {
    console.error('Error deleting school day:', error);
    throw error;
  }
};
